import { configureStore } from '@reduxjs/toolkit';
import CustomerDetailsReducer from './customerDetailsInfo';

export default configureStore({
  reducer: {
    customerDetailsInfo: CustomerDetailsReducer,
  },
})